import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../hooks";
import React from "react";
import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogContent,
  Typography,
  Grid,
  Button,
  Box,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "15px",
    background: "#fff",
    overflow: "hidden",
    [theme.breakpoints.up("sm")]: {
      width: "85%",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "35%",
    },
  },
}));

const HeaderBox = styled(Box)(({ color }) => ({
  background: color,
  padding: "25px 20px 30px",
  textAlign: "center",
  position: "relative",
}));

const ContentBox = styled(Box)(({ theme }) => ({
  padding: "20px",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "16px",
  },
}));

function URLVerification() {
  const axios = useAxios();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const sig = queryParams.get("sig");
  const visitor_id = queryParams.get("visitor_id");

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!!sig) {
      axios({
        url:
          "/notification/notification/url-verification?visitor_id=" +
          visitor_id +
          "&url_token=" +
          sig,
        disableRedirect: true,
        disableError: true,
      }).then((response) => {
        if (!response.status) {
          setOpen(true);
        }
      });
    }
  }, []);

  return (
    <StyledDialog open={open} fullWidth maxWidth="sm">
      <HeaderBox color="#e53935">
        <ErrorIcon sx={{ fontSize: "55px", color: "#fff" }} />
        <Typography
          variant="h5"
          fontWeight={700}
          color="white"
          mt={2}
          sx={{ fontSize: "1.5rem" }}
        >
          Link Expired
        </Typography>
      </HeaderBox>

      <DialogContent>
        <ContentBox>
          <Typography variant="body1" sx={{ mb: 2 }}>
            This verification link has expired or is invalid.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Kindly contact the admin for further assistance.
          </Typography>
        </ContentBox>
      </DialogContent>
    </StyledDialog>
  );
}

export default URLVerification;
